import request from '@/utils/request'

// 查询合同开票列表
export function listHtkp(query) {
  return request({
    url: '/xm/htkp/list',
    method: 'get',
    params: query
  })
}
// 查询合同开票列表
export function nplistHtkp(query) {
  return request({
    url: '/xm/htkp/nplist',
    method: 'get',
    params: query
  })
}
// 查询合同开票详细
export function getHtkp(id) {
  return request({
    url: '/xm/htkp/' + id,
    method: 'get'
  })
}

// 查询合同开票详细
export function sqshHtkp(id) {
  return request({
    url: '/xm/htkp/sqsh/' + id,
    method: 'get'
  })
}

export function kylistHtkp(query){
  return request({
    url: '/xm/htkp/kylist',
    method: 'get',
    params: query
  })
}

export function shlcHtkp(data){
  return request({
    url: '/xm/htkp/shlc',
    method: 'post',
    data: data
  })
}

// 新增合同开票
export function addHtkp(data) {
  return request({
    url: '/xm/htkp',
    method: 'post',
    data: data
  })
}

// 修改合同开票
export function updateHtkp(data) {
  return request({
    url: '/xm/htkp',
    method: 'put',
    data: data
  })
}

// 删除合同开票
export function delHtkp(id) {
  return request({
    url: '/xm/htkp/' + id,
    method: 'delete'
  })
}



// WEBPACK FOOTER //
// ./src/api/xm/htkp.js